import { StepListResponse } from 'hooks';
import { themeObject } from 'lib';

export interface UpdateStepDetailsFormDataProps {
    control: any;
    errors: Record<string, any>;
    stepDetailsFormValues: StepListResponse;
    handleUnsavedChanges?: () => void;
}

export const stepDetailsFormStyles = {
    headingTextStyles: {
        ...themeObject.typography.h3,
        color: themeObject.palette.primary[700],
    },
    dividerStyles: {
        weight: '1px',
        color: themeObject.palette.grayScale[200],
        mb: 1,
    },
};
